import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

const OffCampusPage = lazy(() => import('src/pages/off-campus'));
const LearningPlanPage = lazy(() => import('src/pages/off-campus/learning-plan'));
const SettingsPage = lazy(() => import('src/pages/off-campus/settings'));
const WorksitePage = lazy(() => import('src/pages/off-campus/worksite'));
const PlacementPage = lazy(() => import('src/pages/off-campus/placement'));
const ReferralPage = lazy(() => import('../../pages/off-campus/referral'));
const ReferralsPage = lazy(() => import('src/pages/off-campus/referrals'));
const PlacementsPage = lazy(() => import('src/pages/off-campus/placements'));
const WorksitesPage = lazy(() => import('src/pages/off-campus/worksites'));

// ----------------------------------------------------------------------

// Off-campus is the coordinator's workspace. The secretary sees all of it and
// does the work the coordinators give them (Off Campus settings). Counsellors
// can only open a placement (read-only), from a student's Career tab.
const COORDINATOR = [ROLES.USER_ROLE_OFF_CAMPUS_COORDINATOR];
const OFF_CAMPUS_STAFF = [ROLES.USER_ROLE_OFF_CAMPUS_COORDINATOR, ROLES.USER_ROLE_OFF_CAMPUS_SECRETARY];
const PLACEMENT_VIEWERS = [...OFF_CAMPUS_STAFF, ROLES.USER_ROLE_COUNSELOR];

const guard = (roles, page) => (
  <RoleBasedGuard navigateTo roles={roles}>
    {page}
  </RoleBasedGuard>
);

export const offCampusRoutes = [
  {
    path: 'off-campus',
    element: guard(OFF_CAMPUS_STAFF, <OffCampusPage />),
  },
  // The lists, each its own page (they were tabs on the overview)
  {
    path: 'off-campus/referrals',
    element: guard(OFF_CAMPUS_STAFF, <ReferralsPage />),
  },
  {
    path: 'off-campus/placements',
    element: guard(OFF_CAMPUS_STAFF, <PlacementsPage />),
  },
  {
    path: 'off-campus/worksites',
    element: guard(OFF_CAMPUS_STAFF, <WorksitesPage />),
  },
  {
    path: 'off-campus/learning-plan',
    element: guard(COORDINATOR, <LearningPlanPage />),
  },
  {
    path: 'off-campus/settings',
    element: guard(OFF_CAMPUS_STAFF, <SettingsPage />),
  },
  // The templates moved into settings; old links still land on them
  {
    path: 'off-campus/email-templates',
    element: <Navigate to="/off-campus/settings?tab=email-templates" replace />,
  },
  {
    path: 'off-campus/referrals/:referralId',
    element: guard(OFF_CAMPUS_STAFF, <ReferralPage />),
  },
  {
    path: 'off-campus/worksites/:worksiteId',
    element: guard(OFF_CAMPUS_STAFF, <WorksitePage />),
  },
  {
    path: 'off-campus/placements/:placementId',
    element: guard(PLACEMENT_VIEWERS, <PlacementPage />),
  },
];
